import React, { useEffect } from "react";
import classNames from "classnames";
import { useRouteError } from "react-router-dom";
import Button from "@app/components/Button";
import Accordion from "@app/components/Accordion";
import { Col, Container, Row } from "react-bootstrap";
import Icon from "@app/components/Icon";
import PageWrapper from "@app/components/PageWrapper";

const RootErrorBoundary = () => {
	const ErrorBoundaryInspectionClassName = classNames();
	const error = useRouteError();
	console.warn("Error catched by ErrorBoundary:", error.name);
	console.warn(error);

	useEffect(() => {
		if (error.name === "AuthRequiredError") {
			console.log("error boundary do redirect", error);
			document.cookie = `redirectTo=${encodeURIComponent(error.redirect)}; Path=/; Max-Age=600; SameSite=Lax`;
			window.location.href = `${Config.API.BASE_PATH}/auth?app=tempton_azure`;
		}
	}, [error.name]);

	return (
		<PageWrapper vBetween={true}>
			<div />
			<Container className={`${ErrorBoundaryInspectionClassName} align-self-center`}>
				<Row className={"justify-content-center mb-18"}>
					<Col xs={"auto"}>
						{error.name === "OutdatedError" && <Icon icon={"no-wlan"} size={160} />}
						{error.name === "AuthRequiredError" && <Icon icon={"user"} size={160} />}
						{error.name !== "OutdatedError" && error.name !== "AuthRequiredError" && (
							<Icon icon={"no-wlan"} size={160} />
						)}
					</Col>
				</Row>
				<Row className={"justify-content-center"}>
					<Col sm={10} md={6} lg={5} className={"text-center"}>
						{error.name === "OutdatedError" && (
							<>
								<h2>Die geladenen Daten sind veraltet</h2>
								<br />
								<p className={"mt-4"}>
									Bitte stellen Sie eine Internetverbindung her und laden dann die Anwendung neu:
								</p>
							</>
						)}
						{error.name === "AuthRequiredError" && (
							<>
								<h2>{error.message}</h2>
							</>
						)}

						{error.name !== "OutdatedError" && error.name !== "AuthRequiredError" && (
							<h2>Es ist ein Fehler aufgetreten</h2>
						)}
					</Col>
				</Row>
			</Container>
			<Container className={`${ErrorBoundaryInspectionClassName} align-self-center`}>
				{error.name === "OutdatedError" && (
					<Row className={"justify-content-center align-items-end pt-30"}>
						<Col sm={10} md={6} lg={5} className={"justify-content-center d-flex"}>
							<Button label={"Anwendung neu laden"} callback={() => window.location.reload()} />
						</Col>
					</Row>
				)}
				{error.name !== "OutdatedError" && error.name !== "AuthRequiredError" && (
					<Row className={"justify-content-center align-items-end pt-30"}>
						<Col sm={10} md={6} lg={5}>
							<p className={"mt-4"}>
								Falls der Fehler Weiterhin auftritt, können Sie sich mit diesen Informationen an den
								Support wenden:
							</p>
							<Accordion subHeadline={<p className={"fw-bold mb-0"}>Error-Log</p>}>
								<p>Location: {window.location.href}</p>
								<pre>{error.stack}</pre>
							</Accordion>
						</Col>
					</Row>
				)}
			</Container>
		</PageWrapper>
	);
};

RootErrorBoundary.propTypes = {};

export default RootErrorBoundary;
